import AnimatedLoader from '../../../components/AnimatedLoader';
import '../../../styles/containers/SavingsCalculator/savingsCalculator.scss';
// import '../../../styles/containers/Prayer/components/select-faith.scss';
// import Faiths from './Faiths';
// import faiths from '../../../constants/PrayerFaithsConstants';
import React from 'react'
import {useEffect, useState} from 'react'
import useMoengage from '../../../hooks/useMoengage';
import NextButton from './NextButton';
import {Routes} from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import NavigationSection from './NavigationSection';
import SavingsCalculatorConstants from '../../../constants/SavingsCalculatorConstants'
import RoutingService from '../../../services/RoutingService';
import axios from 'axios';

function SelectMyEarnings() {
  const [userId, setUserId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [selectedEarning, setSelectedEarning] = useState(null);
  const [error, setError] = useState(false);
  const [createMoengageUser, trackEvent] = useMoengage();

  useEffect(() => {
      const paramString = window.location.href.split('?')[1];
      const queryString = new URLSearchParams(paramString);
      let userIdParam;
      queryString.forEach((value, key) => {
        if (key === 'userId') userIdParam = value;
      });
      if (!userIdParam) return;
      else {
        async function fetchUserInfo(endPoint, query) {
          var config = {
              method: 'get',
              url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
              headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Allow-Credentials': 'true',
                  'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
                  'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
                  "Cache-Control": null,
                  "X-Requested-With": null
              },
          };

          return axios(config).then((response) => {
              if (response.status === 200) {
                  return response.data;
              } else {
                  throw new Error('Server Error');
              }
          })
      }
      fetchUserInfo('user_details', `userId=${userIdParam}`)
                .then((userData) => {
                    const name=userData.name;
                    createMoengageUser(userIdParam, name, userData.phoneNumber);
                    console.log("Created Mongaege User: ", userData);
                }).catch((e) => {
                    console.log(e.toString());
                    setError(e.toString());
                    // setIsLoading(false);
                    // setTimeout(() => Navigation.push({pathname: Routes.SELECT_FAITH, search:`userId=${userIdParam}`}), 5000);
                  })
            setIsLoading(false);
            setUserId(userIdParam);
      };
  },[])

  const handleNextButtonClick = function () {
      RoutingService.gotoMySavings({
        search:`userId=${userId}`,
        amount: selectedEarning,
      });
      trackEvent('weekly_earnings', {earnings: selectedEarning});
  }

  return isLoading ? (
    <AnimatedLoader containerStyle={{ height: '100vh' }} />
  ) : (<div className='__main-container' style={{ minHeight: '100vh' }}>
    <NavigationSection path={`${Routes.SELECT_EARNINGS}`} search={`userId=${userId}`} />
    <div className='__horizontal-center select-faith-heading' style={{
      marginTop:'8%',
    }}>How much do you earn every week?</div>
    <div className="row justify-content-between">

      {
        SavingsCalculatorConstants.EARNING.map((earning, index) => (
          <div style={{
            marginTop:'8%',
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
            <div style={{
              position: 'relative',
              width: '260px',
              height: '59px',
              background: '#FFFFFF',
              border: earning.value== selectedEarning ?'3px solid #C69A00':'1px solid #DDDDDD',
              boxSizing: 'border-box',
              borderRadius: '12px',
              cursor: 'pointer',
            }}  
            onClick={() => 
              setSelectedEarning(earning.value)
            }
            >

              <div className="d-flex justify-content-center align-items-center">
                <span style={{
                  position: 'absolute',
                  top: '30%',
                  fontFamily: 'Open Sans',
                  fontStyle: 'normal',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  lineHeight: '150%',
                  color:earning.value== selectedEarning ?'#C69A00':'#111111',
                }}>{earning.value}</span>
              </div>
            </div>
          </div>

        ))}

      </div>

        <NextButton handleClick={handleNextButtonClick} selectedEarning={selectedEarning}/>

    </div>
  )
}

export default SelectMyEarnings



